import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'
import { ActionPlanMessageType } from '../ActionPlan/actionPlanConfig.types'

const textColorMap: Record<ActionPlanMessageType, (theme: TTheme) => string> = {
    'security-alert': (theme) => theme.colors.reds[500],
    'critical-issues': (theme) => theme.colors.reds[500],
    mdr: (theme) => theme.colors.teals[900],
    'low-priority-issues': (theme) => theme.colors.greys[900],
    'low-priority-action': (theme) => theme.colors.greys[900],
    general: (theme) => theme.colors.greys[900],
    'important-action': (theme) => theme.colors.primary[900],
}

export const ItemWrapper = styled('div')<{
    type: ActionPlanMessageType
    theme?: TTheme
}>`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    border-radius: 12px;
    transition:
        background-color 0.2s ease,
        border-color 0.2s ease;

    &:not(:last-child) {
        margin-bottom: 12px;
    }

    background-color: ${({ theme }) => theme.colors.greys[50]};
    border: 1px solid ${({ theme }) => theme.colors.semantic.overviewSeparator};

    &:hover {
        background-color: ${({ theme }) => theme.colors.greys[100]};
        border-color: ${({ theme }) => theme.colors.greys[200]};
    }
`

export const IconWrapper = styled('div')<{
    type: ActionPlanMessageType
    theme?: TTheme
}>`
    margin-right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background-color: ${({ theme }) =>
        theme.colors.semantic.backgroundSecondary};
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.colors.semantic.overviewSeparator};
    filter: drop-shadow(0 0 8.242px ${({ theme }) => theme.colors.greys[100]});
    color: ${({ theme, type }) => textColorMap[type](theme)};
`

export const ContentWrapper = styled('div')<{
    type: ActionPlanMessageType
    theme?: TTheme
}>`
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 4px;

    .title {
        color: ${({ theme, type }) => textColorMap[type](theme)};
    }

    .call-to-action {
        color: ${({ theme }) => theme.colors.greys[800]};
        font-weight: var(--font-weight-light);
    }
`

export const ActionArrowWrapper = styled('div')<{ theme?: TTheme }>`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
`
